import Alertify from '@/plugin/alertify'
import App from '@/pages/App'
import Http from '@/plugin/resource'
import Mask from 'v-mask'
import ProgressBar from '@/plugin/progress-bar'
import RouterFactory from '@/pages/router-factory'
import Routes from './routes'
import StoreFactory from '@/pages/store-factory'
import Stores from './stores'
import Vue from 'vue'
import VueFlatPickr from 'vue-flatpickr-component'

import '@/styles/global.scss'
import 'flatpickr/dist/flatpickr.css'

const Router = RouterFactory.create(Routes)
const Store  = StoreFactory.create(Stores)

Vue.use(Mask)
Vue.use(Alertify);
Vue.use(Http);
Vue.use(ProgressBar);
Vue.use(VueFlatPickr);

new Vue({
  http   : Http,
  router : Router,
  store  : Store,
  render : h => h(App),
}).$mount('#vue-app-container')
